import type { ActivityContact } from '@/api/gamma-team/types';

import { toContactHref } from '../../address-book/modules/address-book-board/utils/contact-presentation';

export const HISTORY_TAB_SEARCH = '?tab=history';

export const toContactHistoryHref = (contact: ActivityContact): string | null =>
  contact.deleted ? null : `${toContactHref(contact)}${HISTORY_TAB_SEARCH}`;
